import { render, staticRenderFns } from "./LocationNote.vue?vue&type=template&id=09b7a232&"
import script from "./LocationNote.vue?vue&type=script&lang=js&"
export * from "./LocationNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports